export type LegalKey = 'terminos' | 'privacidad' | 'seguridad';

interface Section {
  heading?: string;
  paragraphs: string[];
  list?: string[];
}
interface LegalDoc {
  title: string;
  updated: string;
  sections: Section[];
}

export const LEGAL_CONTENT: Record<LegalKey, LegalDoc> = {
  terminos: {
    title: 'Términos y Condiciones',
    updated: 'Julio 2026',
    sections: [
      {
        paragraphs: [
          'Estos Términos y Condiciones regulan el uso de la plataforma del Programa de Mentoría de Mitsui & Co. (la "Plataforma"). Al acceder o utilizar la Plataforma, aceptas estos términos en su totalidad.',
        ],
      },
      {
        heading: '1. Uso de la Plataforma',
        paragraphs: [
          'La Plataforma es de uso exclusivo para participantes autorizados del programa (mentores, mentees y administradores). El acceso se otorga mediante credenciales asignadas y es personal e intransferible.',
        ],
        list: [
          'No compartas tus credenciales de acceso con terceros.',
          'Utiliza la Plataforma únicamente para los fines del programa de mentoría.',
          'Mantén un trato respetuoso y profesional con tu contraparte.',
        ],
      },
      {
        heading: '2. Contenido y responsabilidades',
        paragraphs: [
          'Eres responsable del contenido que registres en la Plataforma (objetivos, FODA, planes de desarrollo, sesiones y feedback). La organización se reserva el derecho de moderar o remover contenido que infrinja estos términos.',
        ],
      },
      {
        heading: '3. Disponibilidad del servicio',
        paragraphs: [
          'Nos esforzamos por mantener la Plataforma disponible de forma continua, pero no garantizamos que esté libre de interrupciones. Podremos realizar mantenimientos programados notificando cuando sea posible.',
        ],
      },
      {
        heading: '4. Modificaciones',
        paragraphs: [
          'Podremos actualizar estos términos periódicamente. El uso continuado de la Plataforma tras una actualización implica la aceptación de los términos vigentes.',
        ],
      },
    ],
  },
  privacidad: {
    title: 'Política de Privacidad',
    updated: 'Julio 2026',
    sections: [
      {
        paragraphs: [
          'Esta Política de Privacidad describe cómo tratamos los datos personales de los participantes del Programa de Mentoría de Mitsui & Co.',
        ],
      },
      {
        heading: '1. Datos que recopilamos',
        paragraphs: ['Recopilamos los datos necesarios para operar el programa:'],
        list: [
          'Datos de identificación y contacto (nombre, correo, cargo, empresa).',
          'Información del programa (dupla asignada, objetivos, FODA, plan de desarrollo, sesiones y feedback).',
          'Datos técnicos de uso necesarios para el funcionamiento y la seguridad de la Plataforma.',
        ],
      },
      {
        heading: '2. Finalidad del tratamiento',
        paragraphs: [
          'Utilizamos los datos para gestionar la relación de mentoría, dar seguimiento al avance del plan de desarrollo, coordinar sesiones y generar reportes agregados para la administración del programa.',
        ],
      },
      {
        heading: '3. Confidencialidad y acceso',
        paragraphs: [
          'El feedback de las sesiones y la información del plan se comparten únicamente entre la dupla y la administración del programa, conforme al rol de cada usuario. No vendemos ni cedemos datos personales a terceros ajenos al programa.',
        ],
      },
      {
        heading: '4. Comunicaciones',
        paragraphs: [
          'Enviamos notificaciones operativas (avisos de sesiones, consentimiento, recordatorios) desde no-reply@kuali.ai. Estas comunicaciones son parte del funcionamiento del programa.',
        ],
      },
      {
        heading: '5. Tus derechos',
        paragraphs: [
          'Puedes solicitar acceso, rectificación o eliminación de tus datos personales a través de la página de contacto. Atenderemos tu solicitud conforme a la normativa aplicable.',
        ],
      },
    ],
  },
  seguridad: {
    title: 'Seguridad de la Información',
    updated: 'Julio 2026',
    sections: [
      {
        paragraphs: [
          'La seguridad de la información de los participantes es una prioridad. Aplicamos medidas técnicas y organizativas para proteger los datos de la Plataforma.',
        ],
      },
      {
        heading: '1. Autenticación y acceso',
        paragraphs: [
          'El acceso requiere credenciales individuales. Las contraseñas se almacenan cifradas (hash) y nunca en texto plano. El acceso a la información está segmentado por rol (mentor, mentee, administrador).',
        ],
      },
      {
        heading: '2. Protección de datos en tránsito',
        paragraphs: [
          'La comunicación entre tu navegador y la Plataforma se realiza sobre conexiones cifradas (HTTPS/TLS).',
        ],
      },
      {
        heading: '3. Buenas prácticas del usuario',
        paragraphs: ['Ayúdanos a mantener tu cuenta segura:'],
        list: [
          'Usa una contraseña robusta y cámbiala periódicamente.',
          'No compartas tus credenciales ni las reutilices en otros servicios.',
          'Cierra sesión al usar equipos compartidos.',
          'Reporta cualquier actividad sospechosa a través de la página de contacto.',
        ],
      },
      {
        heading: '4. Incidentes',
        paragraphs: [
          'En caso de detectar un incidente de seguridad que afecte tus datos, actuaremos con prontitud para contenerlo y, cuando corresponda, te informaremos oportunamente.',
        ],
      },
    ],
  },
};
